














































































import Vue from 'vue';
import SideBar from '@/components/sidebar/SideBar.vue';
import { decryptPlainText, updateLoginState, validatePasswords, getUserAttributes, setUserAttributes, hideLoader, showLoader } from '@/util';
import { getUserData, reset, validateResetPasswordCode } from '@/api';
import { ValidationMessages, Routes } from '@/constants';
import { acceptTerms, signIn } from '@/core';

export default Vue.extend({
  name: 'ResetPassword',
  components: {
    SideBar
  },
  data () {
    return {
      password: '',
      confirmPassword: '',
      user: {
        email: '',
        verificationCode: ''
      },
      showPassword: {
        password: false,
        confirmPassword: false
      },
      errors: [] as string[],
      isComponentVisible: false
    };
  },
  mounted () {
    const email = this.$route.query.email;
    const verificationCode = this.$route.query.verificationCode;
    this.user.email = (email && decryptPlainText(email.toString())) || '';
    this.user.verificationCode = (verificationCode && decryptPlainText(verificationCode.toString())) || '';
    this.validateResetCode();
  },
  methods: {
    submit () {
      this.errors = [];
      const message = validatePasswords(this.password, this.confirmPassword, this.user.email);
      if (message) {
        this.errors.push(message);
      } else {
        showLoader();
        this.resetPassword();
      }
    },
    resetPassword () {
      const date = new Date();
      reset(this.user.email, this.user.verificationCode, this.password).then(_ => {
        this.handleSuccess(date);
      }).catch(err => {
        this.handleFailure(err);
      });
    },
    handleSuccess (date: Date) {
      signIn(this.user.email, this.password)
        .then(user => {
          if (!user.attributes['custom:acceptTerms']) {
            acceptTerms(user, date);
          }
          setUserAttributes(getUserAttributes(user.attributes));
          this.setUserDetails();
        }).catch(_ => {
          hideLoader();
        })
    },
    handleFailure (err: any) {
      if (err.response) {
        const { errors } = err.response.data;
        if (errors.length) {
          this.errors.push(ValidationMessages.passwordValidation);
        }
      }
      hideLoader();
    },
    setUserDetails () {
      getUserData().then(_ => {
        hideLoader();
        updateLoginState('/');
      });
    },
    handleInvalidCodeException () {
      hideLoader();
      this.$router.push({ name: Routes.SIGNIN, query: { email: this.user.email, redirectTo: 'reset' } });
    },
    setComponentVisible () {
      this.isComponentVisible = true;
    },
    validateResetCode () {
      validateResetPasswordCode(this.user.email, this.user.verificationCode).then(_ => {
        this.setComponentVisible();
      }).catch(_ => {
        this.handleInvalidCodeException();
      })
    }
  }
});
